export interface Faq {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Judo Coach Ready after purchasing?',
    a: 'You receive digital access to the material after your purchase is completed. The full package is delivered as PDF resources.',
  },
  {
    q: 'Is this an app?',
    a: 'No. Judo Coach Ready is a PDF-based coaching system. If the visual presentation shows a “Session Finder,” it is there to illustrate how the material is organized, but the actual product is delivered in PDF format.',
  },
  {
    q: 'Is this a visual product or mostly text?',
    a: 'It is a highly visual coaching system. The material includes step-by-step technique breakdowns, diagrams, comparison pages, session structures, coaching cards, checklists and visual progressions — not just text-heavy explanations.',
  },
  {
    q: 'Does the package contain videos?',
    a: 'No. This product does not include videos. It is a digital PDF-based coaching system.',
  },
  {
    q: 'Is the material in English?',
    a: 'Yes. The complete system is provided in English.',
  },
  {
    q: 'Can I edit the files?',
    a: 'No. The package is delivered as completed PDF resources and is not provided in editable format.',
  },
  {
    q: 'Is this only for beginner coaches?',
    a: 'No. The system helps coaches work with athletes from beginner foundations through more advanced technical and situational development.',
  },
  {
    q: 'Is this tied to one specific Judo federation?',
    a: 'No. The system is based on broadly applicable Judo coaching principles and practical athlete development.',
  },
]
